module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Historical_Background"
    }
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('b', [_vm._v("HISTORICAL BACKGROUND")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Once a good battlefield always a good battlefield")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Rose E B Coombs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Roughly five miles to the north of the Aisne is the Chemin des Dames road. The ‘Ladies’ Way’ was built on the order of Louis XV in 1770 to ease the carriage of his daughters, Adélide and Victoire, on their way from the Royal Palace of Compiègne to the rural residence of their former governess, the Comtesse de Narbonne Lara, in the Château de la Bove near Bouconville. The Chemin des Dames bisects an area of land referred to as "), _c('i', [_vm._v("le triangle mystique")]), _vm._v("; the apex is centered on the hilltop citadel of Laon, with Soissons and Reims forming the base. Enclosed within this area, three ancient provinces of northern France meet: Picardy, Île de France, and Champagne. These three regions form a crossroads connecting Flanders – and thus much of northern Europe – with the Paris basin, and therefore most of France. Old battlefields are everywhere here. Stretching for no more than twenty-five miles east to west, the Chemin des Dames is a microcosm of this area of France that has often been referred to as the ‘Cockpit of Europe’.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Julius Caesar, in his history of the war against the Gauls, mentions the capture of the fortress of Bibrax held by the Remi tribe, near present day Berry-au-Bac. Napoleon fought his last successful battle at Craonne on 7 March 1814, against a joint Prussian and Russian army under the command of Field Marshal Blücher. The Marie-Louise Monument at Le Ferme d’Hurtebise commemorates the Napoleonic legacy of 1814 and the struggle of the French "), _c('i', [_vm._v("poilu")]), _vm._v(" in 1914. The British Expeditionary Force fought here in September 1914 against the retreating German army. French troops, commanded by General Robert Nivelle, captured part of the Chemin des Dames Ridge from the Germans at a tremendous cost in men in 1917. In October French forces, this time under General Henri-Philippe Pétain, managed to push the Germans back even further in an audacious set piece battle at Malmaison, finally wresting the whole of the Chemin des Dames out of the enemy’s hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By early 1918 the region had become almost a tranquil backwater. The front line still ran across the Chemin des Dames, but actual fighting was desultory; a system of ‘live and let live’ prevailed amongst the French and German combatants. This period of calm was shattered in May 1918, when the German Seventh Army attacked from the north.")])]), _c('p', {
    staticClass: "fig-img",
    attrs: {
      "id": "map_3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_10.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("British Units on the Chemin des Dames, morning of 27 May")])])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13345de5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Historical_Background.vue
// module id = 81
// module chunks = 0